import React, { Component } from 'react';
// import Loading from '../components/LoadingPage';
import { Link } from 'react-router-dom';
import '../static/css/AcceptSignUp.css';
import logo from '../static/images/images/a_logo.jpg';

class AcceptSignUp extends Component {
    constructor() {
        super();
        this.state = {};
        this.onSubmit = this.onSubmit.bind(this);
    };

    async onSubmit(event) {
        event.preventDefault();
        // this.setState({ isLoading: true, })      
        window.location.href = "/signup/community";
    };

    render() {
        return (
            <div className="accept-signup-container">
                <div className="animates-logo-container"><Link to={'/coming-soon'}><img className="animates-logo hover" src={logo} alt="" /></Link></div>

                <div className="accept-signup-box">
                    <h2 className="color-1" style={{marginBottom: "-5px", fontFamily: "'Chelsea Market', cursive"}}><u>Continue to Sign Up</u></h2>

                    <p>Create your account now to claim your display name and earn an exclusive founding member badge! Display names are first come, first served — once it’s taken, it’s gone! <span role="img" aria-label="" style={{fontSize: "12px"}}>🚀</span></p>

                    <h2 className="color-2" style={{fontFamily: "Chelsea Market, cursive", marginTop: "50px", marginBottom: "-10px"}}><u>With this sign up you’ll unlock:</u></h2>
                    <ul style={{paddingInlineStart: "0px", marginBottom: "50px"}}>
                        <li style={{listStyle:"none"}}><span role="img" aria-label="">🏅</span> Founding Member Exclusive Badge</li>
                        <li style={{listStyle:"none"}}><span role="img" aria-label="">🏷️</span> Claimed Display Name</li>
                        <li style={{listStyle:"none"}}><span role="img" aria-label="">⚡️</span> Bonus Power Level Boost Opportunity</li>
                    </ul><br />

                    <p className="accept-signup-box-signup">
                        By continuing, you agree to AniMates's <Link to="/terms-of-service" className="no-dec"><strong>Terms Of Service</strong></Link>. We Will manage information about you as described in our <Link to="/privacy" className="no-dec"><strong>Privacy Policy</strong></Link>, and <Link to="/cookies" className="no-dec"><strong>Cookie Policy</strong></Link>.
                    </p>

                    <form onSubmit={this.onSubmit}><button className="accept-signup-with-email">Continue</button></form>
                </div>
                <p className="welcomecs-footer-bottom-title" style={{fontSize: "10px"}}>© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    };
};

export default AcceptSignUp;